import { render } from "./ComputeOfferingSelection.vue?vue&type=template&id=90edabe4&scoped=true"
import script from "./ComputeOfferingSelection.vue?vue&type=script&lang=js"
export * from "./ComputeOfferingSelection.vue?vue&type=script&lang=js"

import "./ComputeOfferingSelection.vue?vue&type=style&index=0&id=90edabe4&lang=less&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90edabe4"]])

export default __exports__